// Full-page scroll lock for overlays. iOS ignores overflow:hidden on the
// body for touch scrolling, so the lock fixes the body at its current
// scroll offset — the page cannot move until unlocked.
let lockedScrollY = 0
let locked = false

export function lockBody() {
  if (locked) return
  locked = true
  lockedScrollY = window.scrollY
  const style = document.body.style
  style.position = "fixed"
  style.top = `-${lockedScrollY}px`
  style.left = "0"
  style.right = "0"
  style.width = "100%"
  style.overflow = "hidden"
}

export function unlockBody() {
  if (!locked) return
  locked = false
  const style = document.body.style
  style.position = ""
  style.top = ""
  style.left = ""
  style.right = ""
  style.width = ""
  style.overflow = ""
  window.scrollTo(0, lockedScrollY)
}

// A fresh page is never locked; clears stale locks after Turbo visits.
document.addEventListener("turbo:load", unlockBody)
